import { Subscription } from 'rxjs';
import { Component } from '@angular/core';
import { SeoService } from '../../services/seo.service';
import { CoreService } from '../../services/core.service';
import { FAQCategories } from '../../services/faqs.service';
import { CoreSeoPages } from '@app/store/enums/core-seo-pages';
import { SessionInfo } from '@app/store/models/session-info.interface';

@Component({
  selector: 'app-core-pop-up-landing-page',
  templateUrl: './core-pop-up-landing-page.component.html',
  styleUrls: ['./core-pop-up-landing-page.component.scss']
})
export class CorePopUpLandingPageComponent {

  session_info: SessionInfo
  faq_category = FAQCategories.POPUP
  private subscriptions: Subscription[] = []

  TxtRotate = function (el: Element, toRotate: string[], period: number) {
    this.toRotate = toRotate;
    this.el = el;
    this.loopNum = 0;
    this.period = parseInt(period.toString(), 10) || 2000;
    this.txt = '';
    this.tick();
    this.isDeleting = false;
  }

  constructor(
    private seo: SeoService,
    public coreService: CoreService
  ) {
    this.seo.generateMetaTags(CoreSeoPages.POPUP_LANDING)
    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => this.session_info = si))
  }

}
